export enum EErrorActionTypes {
	setPageError = "setPageError",
	tokenError = "error/tokenError"
}